<template>
  <div class="oscar-night-header">
    <div class="d-flex flex-row-reverse small" v-if="isAuthenticated">
      Logged in as {{ authUser.displayName }}
    </div>
    <nav class="navbar navbar-light bg-light">
      <router-link class="navbar-brand" to="home"><img src="../images/oscars.logo.png"></router-link>
      <button
        class="btn btn-small btn-warning btn-sm"
        v-if="isAuthenticated"
        @click="logout"
      >Logout</button>
    </nav>
    <ul class="nav justify-content-end">
      <li class="nav-item" :class="{active: $route.name === 'Ballot'}">
        <router-link class="nav-link" to="home">Ballot </router-link>
      </li>
      <li class="nav-item" :class="{active: $route.name === 'Scoreboard'}">
       <router-link class="nav-link" to="scoreboard">ScoreBoard</router-link>
      </li>
      <li class="nav-item" :class="{active: $route.name === 'Records'}">
       <router-link class="nav-link" to="records">Records</router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import firebase from 'firebase';

export default {
  name: 'Header',
  data() {
    return {
      authUser: null
    };
  },
  computed: {
    isAuthenticated() {
      firebase.auth().onAuthStateChanged((user) => {
        console.log(user);
        if (user) {
          this.authUser = user;
        } else {
          this.authUser = null;
        }
      });

      return (this.authUser !== null);
    }
  },
  methods: {
    logout() {
      firebase.auth().signOut().then(() => {
        this.$router.replace('login');
      });
    }
  }
};
</script>

<style lang="scss">
  @import '../sass/_config';

  .navbar {
    margin-top: 10px;
  }

  .oscar-night-header {
    margin: 0 0 25px;
  }

  .nav {
    border-bottom: 1px solid $border;
    margin-bottom: 50px;
  }

  .nav-item {
    a {
      border-bottom: 2px solid white;
      color: black;
    }
    &.active a, a:hover {
      border-bottom: 2px solid $gold;
      color: $gold;
    }
  }
</style>
